import { CloseAction } from '../../types';

export const CLOSE_MODAL_T_PREFIX = 'close_brief_modal';

export const translationKeyByCloseAction = {
    [CloseAction.DELETE_BRIEF]: `${CLOSE_MODAL_T_PREFIX}.delete` as const,
    [CloseAction.SET_TO_INACTIVE]: `${CLOSE_MODAL_T_PREFIX}.inactive` as const,
    [CloseAction.MARK_AS_DONE]: `${CLOSE_MODAL_T_PREFIX}.done` as const,
};
